import styled from 'styled-components';

import { Container } from '@views/publico/lazy-loading-informacoes-importantes/informacoes-importantes/styles';

export const InformacoesImportantes = styled.div`
  display: flex;

  @media screen and (max-width: 1300px) {
    ${Container} {
      display: none;
      overflow: hidden;
    }
  }
`;

export const ConteinerEmptyGlobal = styled.div`
  display: flex;
  margin: 0 112px;

  @media screen and (min-width: 1440px) {
    margin: 0 156px;
  }

  @media screen and (max-width: 1240px) {
    margin: 0 32px;
  }

  @media screen and (max-width: 1024px) {
    margin: 0 16px;
  }
`;

export const ConteinerGlobal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  overflow-x: hidden;

  padding: 0 8px;
  margin: 60px calc(112px - 8px);
  min-height: calc(100vh - (96px * 2));

  @media screen and (min-width: 1301px) {
    margin: 60px calc(50px - 8px);
    padding-top: 40px;
  }

  @media screen and (max-width: 1300px) {
    margin: 60px calc(32px - 8px);
    padding-top: 32px;
  }

  @media screen and (max-width: 1024px) {
    margin: 60px calc(32px - 8px) 32px calc(32px - 8px);
    padding-top: 24px;
  }

  @media screen and (max-width: 768px) {
    margin: 60px calc(16px - 8px) 32px calc(16px - 8px);
    padding-top: 24px;
  }
`;

export const ConteinerEnvio = styled.div`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  position: fixed;
  right: 0;

  width: calc(100% - 320px);
  height: 100%;
  padding: 24px 20px 40px;

  overflow-y: auto;

  @media screen and (max-width: 1300px) {
    position: relative;
    width: 100%;
    min-height: calc(100vh - 40px);

    margin-top: 55px;
    padding: 16px;

    overflow-y: auto;
    overflow-x: hidden;
    z-index: 1;
  }
`;

export const TituloConteudo = styled.h1`
  color: ${(props) => props.theme.cores.primaria.variantes[800]};
`;

export const Formulario = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  row-gap: 1rem;

  padding-top: 15px;
  margin: 0 auto;

  width: 37rem;

  h1 {
    align-self: center;
  }

  @media screen and (max-width: 844px) {
    width: 100%;
  }
`;
// TODO: utilizar futuramente para acessibilidade
export const EsconderVisualmente = styled.div`
  position: absolute;

  height: 1px;
  margin: -1px;
  padding: 0;
  width: 1px;

  border: 0;
  clip: rect(0 0 0 0);
  overflow: hidden;
`;
